/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Section_TitleInputs */

const en_landing_studio_section_title = /** @type {(inputs: Landing_Studio_Section_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Ideogram 4.5 studio`)
};

const zh_landing_studio_section_title = /** @type {(inputs: Landing_Studio_Section_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的 Ideogram 4.5 创作台`)
};

/**
* | output |
* | --- |
* | "Your Ideogram 4.5 studio" |
*
* @param {Landing_Studio_Section_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_section_title = /** @type {((inputs?: Landing_Studio_Section_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Section_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_section_title(inputs)
	return zh_landing_studio_section_title(inputs)
});
export { landing_studio_section_title as "landing.studio.section_title" }